import { auth } from "../../configurations/firebaseConfig";

//export const onevocaUrl = "http://localhost:3000";
export const serverUrl = "https://onevoca.org/onevoca/query";
export const privacyPolicyUrl =
  "https://scarlet-deposit-885.notion.site/520dd184da364cbd8ce010699d20d0ee?pvs=4";
export const termsOfUseUrl =
  "https://scarlet-deposit-885.notion.site/901e75020d864469a28d38a87b00a0c4?pvs=4";
export const profileImageUrl = `${serverUrl}/profile/images/`;
